const dasherize = (str) => {
  return str
    .split(/(?=[A-Z])/)
    .map(name => name.toLowerCase())
    .join('-')
}

export default dasherize
